
/* Because sometimes you don't have a better place to put things... */
export class AppUtil {

    /* https://davidwalsh.name/javascript-debounce-function */
    public static debounce(func: Function, wait: number, immediate: boolean = false) {
        let timeout: number | null;
        return function() {
            const context = this;
            const args = arguments;
            const later = () => {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            const callNow = immediate && timeout != null;
            if (timeout != null) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    /* https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf */
    public static throttle(fn: Function, limit: number) {
        let timeoutId: number;
        let lastRan: number;

        return function() {
            const context = this;
            const args = arguments;
            if (!lastRan) {
                fn.apply(context, args);
                lastRan = Date.now();
            } else {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    if ((Date.now() - lastRan) >= limit) {
                        fn.apply(context, args);
                        lastRan = Date.now();
                    }
                }, limit - (Date.now() - lastRan));
            }
        };
    }

    public static isProbablyTouch(): boolean {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }

    public static uuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                       .toString(16)
                       .substring(1);
        }
        return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    }
}
